<template>
  <v-card>
    <!-- <v-card-title>User Login</v-card-title> -->
    <v-list>
      <v-list-tile avatar>
        <v-list-tile-avatar>
          <v-icon large>add</v-icon>
        </v-list-tile-avatar>

        <v-list-tile-content>
          <v-list-tile-title>Add New Account Head</v-list-tile-title>
        </v-list-tile-content>

        <v-list-tile-action>
          <v-btn icon fav small outline @click="onCancelled">
            <v-icon>clear</v-icon>
          </v-btn>
        </v-list-tile-action>
      </v-list-tile>
    </v-list>
    <v-divider></v-divider>
    <v-card-text style="max-height: 85%;">
      <v-form ref="addAccountHeadForm" v-model="valid" lazy-validation>
        <v-layout column>
          <v-flex xs12>
            <v-text-field
              outline
              label="Title *"
              required
              v-model="newItem.title"
              :rules="requiredRules"
            ></v-text-field>
          </v-flex>
          <v-textarea v-model="newItem.notes" outline label="Note/Description"></v-textarea>
        </v-layout>
      </v-form>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn @click="clearForm">Clear</v-btn>      
      <v-btn
        color="blue"
        @click="newItemDo"
        :disabled="!valid || actionButtonClicked"
        :loading="actionButtonClicked"
      >Add</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      actionButtonClicked: false,
      valid: true,
      newItem: {
        title: "",
        notes: ""
      },
      // categories: []
    };
  },
  methods: {
    onCancelled() {
      this.$emit("cancelled");
    },
    onNewItemAdded() {
      this.$emit("added");
      this.clearForm();
      this.onCancelled();
    },
    validate() {
      if (this.$refs.addAccountHeadForm.validate()) {
        this.snackbar = true;
      }
    },
    reset() {
      this.$refs.addAccountHeadForm.reset();
    },
    resetValidation() {
      this.$refs.addAccountHeadForm.resetValidation();
    },
    clearForm() {
      this.newItem.title = "";
      this.newItem.notes = "";
    },
    newItemDo() {
      if (this.$refs.addAccountHeadForm.validate()) {
        this.actionButtonClicked = true;
        this.post("/account_heads", this.newItem).then(res => {
          if (res.data.success) {
            this.onNewItemAdded();
          }
          this.snackbarShow(res.data);
          this.actionButtonClicked = false;
        });
      }
    }
  },
  mounted() {}
};
</script>